import { Controller } from '@hotwired/stimulus'

// Dynamic add/remove form rows for contributor social handles.
// Each row has a service select + handle input. Click "+ Add another" to
// append a new row using the <template> element as the source.
export default class extends Controller {
  static targets = ['rows', 'template', 'addButton']

  connect () {
    this.index = this.rowsTarget.querySelectorAll('[data-row]').length
    this.updateAddButtonState()
  }

  addRow (e) {
    e.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, this.index)
    this.rowsTarget.insertAdjacentHTML('beforeend', html)
    this.index += 1
    this.updateAddButtonState()
  }

  removeRow (e) {
    e.preventDefault()
    e.target.closest('[data-row]').remove()
    this.updateAddButtonState()
  }

  updateAddButtonState () {
    // Cap at the number of available services (7).
    const rowCount = this.rowsTarget.querySelectorAll('[data-row]').length
    this.addButtonTarget.disabled = rowCount >= 7
  }
}
